<template>
  <div v-if="playerOptions.sources[0].src">
	  <video-player
		ref="videoPlayer"
		@play="handleFullScreen"
		:options="playerOptions"
	/>
  </div>
</template>

<script setup>
import {
  shallowRef,
  ref,
  onMounted,
  onUnmounted,
  reactive,
  watch,
  getCurrentInstance,
} from "vue";
import "video.js/dist/video-js.css";
// import 'vue-video-player/src/custom-theme.css';
import { VideoPlayer } from "@videojs-player/vue";
import "video.js/dist/video-js.css";
// import poster from "@/assets/images/videoStar.png"; // 封面图
const { proxy } = getCurrentInstance();
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  poster: {
    type: String,
    default: "",
  },
});
watch(()=>props.src,(newValue,oldValue)=>{
	if(newValue){
		playerOptions.value.poster = props.poster
	playerOptions.value.sources[0].src = props.src
	}
})
onMounted(()=>{
	playerOptions.value.poster = props.poster
	playerOptions.value.sources[0].src = props.src
});
const playerOptions = ref({
  language: "zh-CN", // 语言
  playbackRates: [0.5, 1.0, 1.5, 2.0], // 倍速可选项 可自定义
  playsinline: true,
  controls: true, // 是否展示控制栏
  poster:
    "", // 封面图
  sources: [
	  {
		  src:''
	  }
  ],
});

const handleFullScreen = () => {
  if (!proxy.$refs.videoPlayer?.$el?.player) return;
  // 点击播放时设置默认全屏 proxy可以理解为vue2的this
  //   proxy.$refs.videoPlayer.$el.player.requestFullscreen();
};
</script>
<style lang='less' scoped>
.video-js {
  width: 100%;
  height: 100%;
  /deep/ .vjs-big-play-button {
    line-height: 50px;
    height: 50px;
    width: 80px;
    top: calc(50% - 25px);
    left: calc(50% - 40px);
    margin-top: 0; 
    margin-left: 0;
  }
}
</style>
